const V3banner = () => {
  return (
    <figure>
      <img loading="lazy" src="/images/v3_home_banner.jpg" className="img-fluid w-100" alt="VIR V3" />
    </figure>
  )
}

export default V3banner;